(function () {
  if (window.__LOOP_GOAL_FILTER__) return;
  window.__LOOP_GOAL_FILTER__ = true;

  var SELECTOR = {
    goalGrid: ".goal-grid",
    goalBox: ".goal-box",
    goalText: ".goal-text",
    loopRoot: ".loop-bs-container",
    card: ".loop-bundle-product-card[data-product-handle]",
    cardWrap: ".loop-bundle-product-wrapper",
    section: ".loop-category-container-section",
    sectionTitle: ".loop-category-header h2",
    categoryChip: ".loop-category-item",
    categoryChipTitle: ".loop-bundle-text-category-title-p1, .loop-category-item p",
    categoryContainer: ".loop-bundle-category-section-container"
  };

  var GOAL_TAG_MAP = {
    buildmuscle: ["Build Muscle", "build-muscle"],
    boostenergy: ["Boost Energy", "boost-energy"],
    shredslim: ["Shred & Slim", "shred-slim"],
    fanfavorites: ["Fan Favorite", "fan-favorite"]
  };

  var state = {
    activeGoalId: "",
    activeTags: {},
    tagsByHandle: {},
    tagPromisesByHandle: {},
    observerStarted: false,
    fallbackGridContainer: null
  };

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "");
  }

  function splitTags(value) {
    return String(value || "")
      .split(/[|,]/)
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function listToSet(list) {
    var out = {};
    for (var i = 0; i < list.length; i += 1) {
      out[list[i]] = true;
    }
    return out;
  }

  function hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  function setAnyIntersect(firstSet, secondSet) {
    for (var key in firstSet) {
      if (hasOwn(firstSet, key) && secondSet[key]) {
        return true;
      }
    }
    return false;
  }

  function areTagsReady(cards) {
    for (var i = 0; i < cards.length; i += 1) {
      var handle = cards[i].getAttribute("data-product-handle");
      if (handle && !hasOwn(state.tagsByHandle, handle)) return false;
    }
    return true;
  }

  function getGoalRaw(goalEl) {
    return (
      goalEl.getAttribute("data-goal-tags") ||
      goalEl.getAttribute("data-goal-tag") ||
      (goalEl.querySelector(SELECTOR.goalText) || {}).textContent ||
      ""
    );
  }

  function getGoalId(goalEl) {
    return normalize(getGoalRaw(goalEl));
  }

  function getGoalTagSet(goalEl) {
    var raw = getGoalRaw(goalEl);
    var tags = splitTags(raw);

    if (!tags.length && raw) tags = [raw];

    if (tags.length <= 1) {
      var mapped = GOAL_TAG_MAP[normalize(raw)];
      if (mapped && mapped.length) tags = mapped;
    }

    return listToSet(
      tags
        .map(function (item) {
          return normalize(item);
        })
        .filter(Boolean)
    );
  }

  function queryDom() {
    var root = document.querySelector(SELECTOR.loopRoot);
    var grid = document.querySelector(SELECTOR.goalGrid);
    if (!root || !grid) return null;

    return {
      root: root,
      goalGrid: grid,
      goals: Array.prototype.slice.call(grid.querySelectorAll(SELECTOR.goalBox)),
      cards: Array.prototype.slice.call(root.querySelectorAll(SELECTOR.card)),
      sections: Array.prototype.slice.call(root.querySelectorAll(SELECTOR.section)),
      chips: Array.prototype.slice.call(root.querySelectorAll(SELECTOR.categoryChip))
    };
  }

  function ensureEmptyState(dom) {
    var empty = dom.root.querySelector(".loop-goal-empty-state");
    if (empty) return empty;

    empty = document.createElement("div");
    empty.className = "loop-goal-empty-state";
    empty.textContent = "No meals found for this goal.";
    empty.hidden = true;

    var container = dom.root.querySelector(SELECTOR.categoryContainer) || dom.root;
    container.appendChild(empty);
    return empty;
  }

  function ensureResetButton(dom) {
    if (dom.goalGrid.parentNode.querySelector(".goal-filter-reset-btn")) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "goal-filter-reset-btn";
    btn.textContent = "Show all meals";
    btn.addEventListener("click", function () {
      clearFilter();
    });

    dom.goalGrid.insertAdjacentElement("afterend", btn);
  }

  function clearFallbackGridContainer() {
    if (!state.fallbackGridContainer) return;
    state.fallbackGridContainer.classList.remove("loop-goal-fallback-grid-container");
    state.fallbackGridContainer = null;
  }

  function resolveFallbackGridContainer(dom) {
    if (!dom || !dom.cards.length) return null;
    var firstCard = dom.cards[0];
    var firstWrap = firstCard.closest(SELECTOR.cardWrap);
    if (firstWrap && firstWrap.parentElement) return firstWrap.parentElement;
    if (firstCard.parentElement) return firstCard.parentElement;
    return null;
  }

  function enableUnifiedLayout(dom) {
    if (!dom || !dom.root) return;
    dom.root.classList.add("loop-goal-unified-grid");

    var hasSections = !!dom.sections.length;
    dom.root.classList.toggle("loop-goal-unified-grid-no-sections", !hasSections);

    if (hasSections) {
      clearFallbackGridContainer();
      return;
    }

    var container = resolveFallbackGridContainer(dom);
    if (state.fallbackGridContainer && state.fallbackGridContainer !== container) {
      state.fallbackGridContainer.classList.remove("loop-goal-fallback-grid-container");
      state.fallbackGridContainer = null;
    }

    if (container) {
      container.classList.add("loop-goal-fallback-grid-container");
      state.fallbackGridContainer = container;
    }
  }

  function syncActiveGoal(dom) {
    for (var i = 0; i < dom.goals.length; i += 1) {
      dom.goals[i].classList.toggle("goal-filter-active", getGoalId(dom.goals[i]) === state.activeGoalId);
    }
  }

  function clearFilter() {
    var dom = queryDom();
    if (!dom) return;
    dom.goalGrid.classList.remove("goal-filter-loading");

    for (var i = 0; i < dom.cards.length; i += 1) {
      var wrap = dom.cards[i].closest(SELECTOR.cardWrap) || dom.cards[i];
      wrap.classList.remove("loop-goal-hidden");
    }

    for (var j = 0; j < dom.sections.length; j += 1) {
      dom.sections[j].classList.remove("loop-goal-hidden");
    }

    for (var k = 0; k < dom.chips.length; k += 1) {
      dom.chips[k].classList.remove("loop-goal-hidden");
    }

    ensureEmptyState(dom).hidden = true;
    state.activeGoalId = "";
    state.activeTags = {};
    syncActiveGoal(dom);
  }

  function productTagsToSet(productJson) {
    var source = productJson.tags;
    var raw = Array.isArray(source) ? source : String(source || "").split(",");
    return listToSet(
      raw
        .map(function (item) {
          return normalize(item);
        })
        .filter(Boolean)
    );
  }

  function preloadTags(cards) {
    var tasks = cards.map(function (card) {
      var handle = card.getAttribute("data-product-handle");
      if (!handle || hasOwn(state.tagsByHandle, handle)) return Promise.resolve();
      if (state.tagPromisesByHandle[handle]) return state.tagPromisesByHandle[handle];

      state.tagPromisesByHandle[handle] = fetch("/products/" + handle + ".js", { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("Cannot fetch product tags for " + handle);
          return response.json();
        })
        .then(function (product) {
          state.tagsByHandle[handle] = productTagsToSet(product);
        })
        .catch(function () {
          state.tagsByHandle[handle] = {};
        })
        .finally(function () {
          delete state.tagPromisesByHandle[handle];
        });

      return state.tagPromisesByHandle[handle];
    });

    return Promise.all(tasks);
  }

  function filterByTags() {
    var dom = queryDom();
    if (!dom || !Object.keys(state.activeTags).length) return;

    var visibleCount = 0;

    for (var i = 0; i < dom.cards.length; i += 1) {
      var card = dom.cards[i];
      var handle = card.getAttribute("data-product-handle");
      var tags = state.tagsByHandle[handle] || {};

      var matched = setAnyIntersect(tags, state.activeTags);

      var wrap = card.closest(SELECTOR.cardWrap) || card;
      wrap.classList.toggle("loop-goal-hidden", !matched);
      if (matched) visibleCount += 1;
    }

    for (var j = 0; j < dom.sections.length; j += 1) {
      var sectionEl = dom.sections[j];
      var hasVisible = !!sectionEl.querySelector(SELECTOR.cardWrap + ":not(.loop-goal-hidden)");
      sectionEl.classList.toggle("loop-goal-hidden", !hasVisible);
    }

    for (var k = 0; k < dom.chips.length; k += 1) {
      var chip = dom.chips[k];
      var chipText = normalize(
        (chip.querySelector(SELECTOR.categoryChipTitle) || {}).textContent || chip.getAttribute("aria-label") || ""
      );
      var chipVisible = false;

      for (var n = 0; n < dom.sections.length; n += 1) {
        var sectionNode = dom.sections[n];
        var sectionText = normalize(
          (sectionNode.querySelector(SELECTOR.sectionTitle) || {}).textContent || ""
        );
        if (sectionText === chipText && !sectionNode.classList.contains("loop-goal-hidden")) {
          chipVisible = true;
          break;
        }
      }

      chip.classList.toggle("loop-goal-hidden", !chipVisible);
    }

    ensureEmptyState(dom).hidden = visibleCount > 0;
  }

  function activateGoal(goalEl) {
    var dom = queryDom();
    if (!dom) return;

    var nextGoalId = getGoalId(goalEl);
    if (!nextGoalId) return;

    if (state.activeGoalId === nextGoalId) {
      clearFilter();
      return;
    }

    state.activeGoalId = nextGoalId;
    state.activeTags = getGoalTagSet(goalEl);
    if (!Object.keys(state.activeTags).length) {
      state.activeTags = listToSet([nextGoalId]);
    }

    syncActiveGoal(dom);
    if (areTagsReady(dom.cards)) {
      filterByTags();
      return;
    }

    dom.goalGrid.classList.add("goal-filter-loading");
    preloadTags(dom.cards)
      .then(function () {
        if (state.activeGoalId !== nextGoalId) return;
        filterByTags();
      })
      .finally(function () {
        if (state.activeGoalId === nextGoalId) {
          dom.goalGrid.classList.remove("goal-filter-loading");
        }
      });
  }

  function handleGoalEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var goalEl = target.closest(SELECTOR.goalBox);
    if (!goalEl) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    if (event.type === "click" || event.type === "keydown") {
      activateGoal(goalEl);
    }
  }

  function initGoalA11y() {
    var dom = queryDom();
    if (!dom) return;

    for (var i = 0; i < dom.goals.length; i += 1) {
      if (!dom.goals[i].hasAttribute("tabindex")) dom.goals[i].setAttribute("tabindex", "0");
      if (!dom.goals[i].hasAttribute("role")) dom.goals[i].setAttribute("role", "button");
    }
  }

  function startObserver() {
    if (state.observerStarted) return;
    state.observerStarted = true;

    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var dom = queryDom();
        if (!dom) return;

        enableUnifiedLayout(dom);
        initGoalA11y();
        ensureEmptyState(dom);
        ensureResetButton(dom);
        syncActiveGoal(dom);
        var preloadPromise = preloadTags(dom.cards);

        if (Object.keys(state.activeTags).length) {
          if (areTagsReady(dom.cards)) {
            filterByTags();
            return;
          }

          dom.goalGrid.classList.add("goal-filter-loading");
          preloadPromise.then(function () {
            if (!state.activeGoalId) return;
            filterByTags();
          }).finally(function () {
            if (state.activeGoalId) {
              dom.goalGrid.classList.remove("goal-filter-loading");
            }
          });
        }
      }, 120);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function bootstrap(retry) {
    var dom = queryDom();
    if (dom) enableUnifiedLayout(dom);
    if (!dom || !dom.cards.length) {
      if (retry < 120) {
        setTimeout(function () {
          bootstrap(retry + 1);
        }, 250);
      } else {
        console.info('[loop-goal-filter] Goal filter DOM not found after 120 retries — skipping initialization on this page.');
      }
      return;
    }

    initGoalA11y();
    ensureEmptyState(dom);
    ensureResetButton(dom);
    syncActiveGoal(dom);
    preloadTags(dom.cards);
    startObserver();
  }

  document.addEventListener("pointerdown", handleGoalEvent, true);
  document.addEventListener("click", handleGoalEvent, true);
  document.addEventListener(
    "keydown",
    function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      handleGoalEvent(event);
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootstrap(0);
    });
  } else {
    bootstrap(0);
  }
})();
